import FormTextFieldDark from "@/components/UI/FormTextFieldDark/FormTextFieldDark";

export default function ElementTitleField(props) {
  const { control, type } = props;

  return (
    <FormTextFieldDark
      name="title"
      label="Title"
      variant="standard"
      fullWidth
      control={control}
      data-analytics={`${type}-field-title`}
    />
  );
}
